import BookmarksIcon from '@mui/icons-material/Bookmarks';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export type Props = {
  dealId?: string | null;
  onClick?: (dealId: string) => void;
  dealIdsToGroup?: string[];
  className?: string;
};

export const GroupByDealIdButton = memo(
  ({ dealId, dealIdsToGroup, onClick, className }: Props) => {
    const { t } = useTranslation();

    if (!onClick || !dealIdsToGroup?.includes(dealId ?? '')) {
      return null;
    }

    return (
      <Tooltip title={t('Show all deals sharing the same external ID')} placement="top">
        <Box
          component="span"
          sx={{
            alignItems: 'center',
            cursor: 'pointer',
            display: 'inline-flex',
            marginLeft: 0.5,
            marginRight: 1.5,
            verticalAlign: 'middle',
          }}
          onClick={() => onClick(dealId ?? '')}
          data-test="dsp-deal-id-group-btn"
          className={className}
        >
          <BookmarksIcon color="action" sx={{ height: '16px', width: '16px' }} />
        </Box>
      </Tooltip>
    );
  },
  (prevProps, nextProps) => isEqual(prevProps, nextProps)
);
